import React from "react";
import PageHeader from "../../components/PageHeader";
import FaqComponentList from "../../components/FAQ/FaqList";

class CmsPagesList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="FAQ"
                            Breadcrumb={[
                                { name: "FAQ", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <FaqComponentList />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CmsPagesList;
